import {api, get} from '../../../config';

export default {
    read: function() {
        return {
            url: api('API_SENDER_TOKEN'),
            dataType: 'json',
            type: 'get',
            data: {
                xref: get('XREF'),
            },
        };
    },
};
